import { createRoute } from '@tanstack/react-router'
import { UserDetailsPage } from '@/features/users/pages/UserDetailsPage'
import { Route as usersRoute } from '../users/route'

export const Route = createRoute({
  getParentRoute: () => usersRoute,
  path: '/$id',
  component: UserDetailsPage,
})
